<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">

      <router-view :key="key"/>

    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.fullPath
    }
  }
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  height: calc(100vh - 80px);
  overflow-y: auto;
  width: 100%;
  position: relative;
  /* overflow: hidden; */
  padding: 20px;
}
</style>

